import {
  ChangeControlStatus,
  RequirementDesignElement,
} from "@design-controls/types";

// TODO(DES-2014): replace with useCompareView data
export const FIXTURE_OLDER: RequirementDesignElement = {
  id: "fixture-requirement",
  code: "UN-1",
  title: "First User Need",
  type: "req1",
  itemStatus: "NEW",
  changeControlStatus: ChangeControlStatus.enum.APPROVED,
  created: "2026-10-01T10:00:00.000Z",
  updated: "2026-10-01T10:00:00.000Z",
  source: "product-development",
  version: "v1",
  major: 1,
  minor: 0,
  policyIssues: {},
  description:
    "<p>The device shall alert the user when the battery is low.</p>" +
    "<ol><li>Show a warning icon</li><li>Play a sound</li></ol>",
  category: { label: "Safety", qri: "" },
  component: { label: "Power", qri: "" },
  attachments: [
    {
      id: "6f1c2a9e-1b7d-4c3e-9a51-0d2f7e8b4c11",
      filename: "Battery specification.pdf",
      filesize: 182_000,
      contentType: "application/pdf",
    },
    {
      id: "a3d4e5f6-7a8b-4c9d-8e0f-1a2b3c4d5e6f",
      filename: "Wiring diagram.png",
      filesize: 96_000,
      contentType: "image/png",
    },
  ],
  parent: [],
  sourcedItems: [],
  mitigates: [],
  children: [
    {
      id: "fixture-child-1",
      code: "DI-1",
      title: "Battery monitor",
      type: "req2",
      major: 1,
      minor: 0,
    },
  ],
};

export const FIXTURE_VIEWED: RequirementDesignElement = {
  ...FIXTURE_OLDER,
  version: "v2",
  major: 2,
  updated: "2026-10-15T10:00:00.000Z",
  description:
    "<p>The device shall alert the user when the battery is below 20%.</p>" +
    "<ol><li>Show a warning icon<ol><li>Flash it when below 5%</li></ol></li>" +
    "<li>Play a sound</li></ol>",
  category: { label: "Usability", qri: "" },
  attachments: [
    FIXTURE_OLDER.attachments[0],
    {
      id: "b7c8d9e0-f1a2-4b3c-9d4e-5f6a7b8c9d0e",
      filename: "Alert sounds.zip",
      filesize: 2_400_000,
      contentType: "application/zip",
    },
  ],
  children: [
    {
      id: "fixture-child-1",
      code: "DI-1",
      title: "Battery monitor",
      type: "req2",
      major: 2,
      minor: 0,
    },
    {
      id: "fixture-child-2",
      code: "TC-1",
      title: "Low battery alert test",
      type: "testCase1",
      major: 1,
      minor: 0,
    },
  ],
};
